// extracted by mini-css-extract-plugin
module.exports = {"notice-row":"ufb-notice_notice-row__dsM4P","notice":"ufb-notice_notice__kHbnv","partner-logos":"ufb-notice_partner-logos__SEnVX"};